import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 100 100" preserveAspectRatio="none" {...props}><path d="M100 100H0V50c33.333 50 66.667-50 100 0" /></svg>);